export default "/icons/app_store_icon.svg";